export default __webpack_public_path__ + "static/thumb-landscape-1d343d2e6f69dbaf7bcb0564ab88f530.jpg";